import React, { ChangeEvent } from 'react';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { CustomTable } from '@dev/ee-components';
import { CampaignTypeFilter } from '@dev/ee-api/ee-api-models';
import { getCampaignsStore, PickCampaigns } from '@/store/campaigns/actions';
import { useTableHeaders } from '@/components/Campaigns/hooks/useTableHeaders';
import { useTableRows } from '@/components/Campaigns/hooks/useTableRows';
import TableFiltersComponent from '../TableFilters';

const columnWidth: Record<string, string> = {
    preview: '11%',
    campaignName: '63%',
    status: '180px',
};

const DraftsTable = (): JSX.Element => {
    const campaigns = useSelector(getCampaignsStore);

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const headers = useTableHeaders();
    const rows = useTableRows({ campaignTypeFilter: [CampaignTypeFilter.Draft] });

    const pickCampaign = (event: ChangeEvent<unknown>, pickedCampaigns: string[]) => {
        event?.stopPropagation?.();
        event?.preventDefault?.();

        dispatch(PickCampaigns(pickedCampaigns));
    };

    return (
        <>
            <TableFiltersComponent />
            <CustomTable
                headers={headers}
                rows={rows}
                loading={false}
                emptyRowsNo={campaigns.pagination.perPage}
                stickyHeader
                rowHeight={112}
                isEmpty={isEmpty(campaigns?.collection) && !campaigns?.loading}
                rowPadding={48}
                columnsWidth={columnWidth}
                onSelectRow={pickCampaign}
                selectedRows={campaigns.checkedCampaigns}
                totalCount={campaigns?.statusCount?.total}
                isHeaderCheckboxEnabled={true}
                disableFirstRowBorderTop={true}
                emptyStateProps={{ text: t('emptystate') }}
                disableRowClick
            />
        </>
    );
};

export default DraftsTable;
